<ol>
    <li *ngFor="let item of checklist$ | async" [class.checked]="checked.get(item.description)">
        <ion-icon [name]="checked.get(item.description) ? 'checkmark-circle-outline' : 'ellipse-outline'"></ion-icon>
        {{ item.description }}
    </li>
</ol>
